import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../provider/AuthProvider";
import DefaultLayout from "../../layout/DefaultLayout";

const AdminRoutes = () => {
  const { userID } = useAuth();

  const isAdmin = userID && Number(userID) < 100;

  return isAdmin ? (
    <DefaultLayout>
      <Outlet />
    </DefaultLayout>
  ) : (
    <Navigate to="/not-found" />
  );
};

export default AdminRoutes;
